module.exports = __webpack_public_path__ + "img/20191212170458633.9804f1a5.jpg";